import { Link } from 'react-router-dom';
import { contactInfo, footerLinks } from '../mock';
import { Mail, Phone, MapPin, Instagram, Linkedin } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="bg-[var(--mm-purple-dark)] text-white/85">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo variant="light" />
          <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-xs">Building connected transformation systems for schools, communities and broadband networks.</p>
          <div className="mt-6 flex gap-3">
            <a href={contactInfo.social.instagram} aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/25 flex items-center justify-center hover:bg-white hover:text-[var(--mm-purple)] transition-colors"><Instagram className="w-4 h-4"/></a>
            <a href={contactInfo.social.linkedin} aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-white/25 flex items-center justify-center hover:bg-white hover:text-[var(--mm-purple)] transition-colors"><Linkedin className="w-4 h-4"/></a>
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm tracking-wider uppercase">Explore</h4>
          <ul className="mt-5 space-y-2.5 text-sm">
            <li><Link to="/transform/school" className="hover:text-white">School Transformation</Link></li>
            <li><Link to="/transform/digital-tlm" className="hover:text-white">Digital TLM Engine</Link></li>
            <li><Link to="/transform/smart-ecce" className="hover:text-white">Smart ECCE</Link></li>
            <li><Link to="/transform/village-schools" className="hover:text-white">Village Schools</Link></li>
            <li><Link to="/netrakshak" className="hover:text-white">NetRakshak</Link></li>
            <li><Link to="/projects" className="hover:text-white">Projects</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm tracking-wider uppercase">Contact</h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0"/><a href={`mailto:${contactInfo.email}`} className="hover:text-white">{contactInfo.email}</a></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0"/><a href={`tel:${contactInfo.phone}`} className="hover:text-white">{contactInfo.phone}</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm tracking-wider uppercase">Offices</h4>
          <ul className="mt-5 space-y-4 text-sm">
            {contactInfo.workAddresses.map((a,i) => (
              <li key={i} className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0"/><span>{a}</span></li>
            ))}
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0"/><span>{contactInfo.registeredAddress}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-[12px] text-white/60">
          <span>© {new Date().getFullYear()} Mashmari Consultants Private Limited. All rights reserved.</span>
          {footerLinks.map(l => (
            l.href.startsWith('/')
              ? <Link key={l.label} to={l.href} className="hover:text-white">{l.label}</Link>
              : <a key={l.label} href={l.href} className="hover:text-white">{l.label}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}
